<template>
    <div id="toogle switch" :class="{'disabled': disabled}" class="mr-1">
      <label class="switch">
        <input type="checkbox" v-bind="$attrs" :checked="checked" :disabled="disabled" @change="onChange">
        <span class="slider round"></span>
      </label>
    </div>
</template>
<script>
export default {
  name: 'Slider',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onChange: function (event) {
      if (!this.disabled) {
        this.$emit('change', event.target.checked)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 39px;
  height: 22.1px;
  margin-bottom: 0 !important;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .25s;
  transition: .25s;
}

.disabled .slider {
  cursor: not-allowed;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16.9px;
  width: 16.9px;
  left: 2.6px;
  bottom: 2.6px;
  background-color: white;
  -webkit-transition: .25s;
  transition: .25s;
}

input:checked + .slider {
  background-color: #29c4a9;
}

input:focus + .slider {
  box-shadow: 0 0 1px #29c4a9;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16.9px);
  -ms-transform: translateX(16.9px);
  transform: translateX(16.9px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 22.1px;
}

.slider.round:before {
  border-radius: 50%;
}

.filters label {
  top: 0 !important;
}
</style>
